// extracted by mini-css-extract-plugin
export default {"collapsible":"AnimatedHeightDiv_collapsible__IbHDD","collapsed":"AnimatedHeightDiv_collapsed__MA3yv"};